export const SET_PREP_FQ_PROFILE = "prep_fq_profile";
export const SAVE_PREP_FQ_FORM = "save_prep_fq_form";
export const CLEAR_PREP_FQ_REDUCER = "clear_prep_fq";
export const SET_PREP_FQ_REPORT = "set_prep_fq_report";
